import { analytics } from '@saucelabs/sl-util-axios';

/**
 * @param {Object} params
 * @param {Array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTestCases(params) {
  return analytics.get('/overview/test-cases', { params });
}
